<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="loco-filters-root" [formGroup]="locoForm">
    <div class="loco-filters miles-empty" autofocus>
        <h2>
            <p-checkbox label="" [tabindex]='tabIndex + 1' name="milesToEmptyCheck" label="Low Fuel" [binary]="true" formControlName="milesToEmptyCheck"></p-checkbox>
        </h2>
        <div class="miles-empty-indent">
            <p> Miles to Empty</p>
            <span class="pull-left less-than"> &#60;</span>
            <lms-spinner formControlName="milesToEmpty" [tabindex]='tabIndex + 2' [minValue]="0" [maxValue]="9999" ngDefaultControl [disabledValue]="!locoForm.controls.milesToEmptyCheck.value"
                [size]="4" [showError]="locoForm.controls.milesToEmptyCheck.value" [inputId]="'milesToEmpty'"></lms-spinner>

        </div>
        <br><br>
        <h2>
            <p-checkbox label="" [tabindex]='tabIndex + 3' name="hoursIdleCheck" label="Idle" [binary]="true" formControlName="hoursIdleCheck"></p-checkbox>
        </h2>
        <div class="miles-empty-indent">
            <p>
                Number of Hrs</p>

            <span class="pull-left less-than">&#62;</span>
            <lms-spinner formControlName="hoursIdle" [tabindex]='tabIndex + 4' [minValue]="0" [maxValue]="999" ngDefaultControl [disabledValue]="!locoForm.controls.hoursIdleCheck.value"
                [size]="3" [showError]="locoForm.controls.hoursIdleCheck.value" [inputId]="'hoursIdle'">
            </lms-spinner>
        </div>
    </div>

    <div class="loco-filters airflow">
        <h2> Due, 33-day, Air Flow</h2>
        <div class="blocks">
            <p-dropdown [tabindex]='tabIndex + 5' [options]="dueDayAirFlowList" formControlName="dueDayAirFlowValue"></p-dropdown>
        </div>
        <div class="blocks">
            <p-radioButton [disabled]="!locoForm.controls.dueDayAirFlowValue?.value" [tabindex]='tabIndex + 8' name="withinDaysRadio" labelStyleClass="due-day-radio-lable"
                value="withinDays" label="Within Days " formControlName="withinDaysRadio" (onClick)="resetDueDayAirFlowRadio('withinDays')"></p-radioButton>

            <lms-spinner formControlName="withinDays" [tabindex]='tabIndex + 9' [minValue]="-999" [maxValue]="999" ngDefaultControl
                [disabledValue]="!(locoForm.controls.withinDaysRadio.value &&locoForm.controls.dueDayAirFlowValue.value)" [size]="4"
                [showError]="(locoForm.controls.withinDaysRadio.value &&locoForm.controls.dueDayAirFlowValue.value)" [inputId]="'withinDays'">
            </lms-spinner>

        </div>

        <div class="blocks">
            <p-radioButton [disabled]="!locoForm.controls.dueDayAirFlowValue.value" [tabindex]='tabIndex + 10' name="allPastDue" labelStyleClass="due-day-radio-lable"
                value="allPastDue" label="All Past Due" formControlName="allPastDue" (onClick)="resetDueDayAirFlowRadio('allPastDue')"></p-radioButton>
        </div>

        <div class="blocks">
            <p-radioButton [disabled]="!locoForm.controls.dueDayAirFlowValue.value" [tabindex]='tabIndex + 11' name="days" labelStyleClass="due-day-radio-lable"
                value="days" label="> Days " formControlName="daysRadio" (onClick)="resetDueDayAirFlowRadio('days')"></p-radioButton>
            <lms-spinner class="filter-spinner" [tabindex]='tabIndex + 12' formControlName="days" [minValue]="-999" [maxValue]="999"
                ngDefaultControl [disabledValue]="!(locoForm.controls.daysRadio.value &&locoForm.controls.dueDayAirFlowValue.value)"
                [size]="4" [showError]="(locoForm.controls.daysRadio.value &&locoForm.controls.dueDayAirFlowValue.value)" [inputId]="'days'">
            </lms-spinner>

        </div>
    </div>

    <div class="loco-filters filter-grp">
        <ul>
            <li>
                <h2>Perm Tag</h2>
                <lms-lms-dropdown [options]="permTagList" [tabindex]='tabIndex + 13' #permTagDropDown (onChange)="permTagDropDown.resetFilter()"
                    formControlName="permTag" [filter]="true"></lms-lms-dropdown>
            </li>
            <li>
                <h2>Loco Tag</h2>
                <lms-lms-dropdown [options]="locoTagList" [tabindex]='tabIndex + 15' #locoTagDropDown (onChange)="locoTagDropDown.resetFilter()"
                    formControlName="locoTag" [filter]="true"></lms-lms-dropdown>
            </li>

            <li>
                <h2>Class Code</h2>
                <lms-lms-dropdown [options]="classCodeList" [tabindex]='tabIndex + 17' #classCodeDropDown (onChange)="classCodeDropDown.resetFilter()"
                    formControlName="classCode" [filter]="true"></lms-lms-dropdown>
            </li>
            <li>
                <h2>Tonnage Category</h2>
                <lms-lms-dropdown [options]="tonnageList" [tabindex]='tabIndex + 19' #tonnageDropDown (onChange)="tonnageDropDown.resetFilter()"
                    formControlName="classCategory" [filter]="true"></lms-lms-dropdown>
            </li>
            <li>
                <h2>Incident</h2>
                <lms-lms-dropdown [options]="incidentList" [tabindex]='tabIndex + 21' #incidentDropDown (onChange)="incidentDropDown.resetFilter()"
                    formControlName="incidentCode" [filter]="true"></lms-lms-dropdown>
            </li>
        </ul>
        <div class="clear yard-local-filter">
            <ul>
                <li>
                    <h2>Yard & Local</h2>
                    <lms-lms-dropdown [options]="yardLocalList" [tabindex]='tabIndex + 23' #yardLocalDropDown (onChange)="yardLocalDropDown.resetFilter()"
                        formControlName="yardLocal" (onChange)="fillYardLocalRespectiveList($event)" [filter]="true"></lms-lms-dropdown>
                </li>
                <li>
                    <h2>&nbsp;</h2>
                    <lms-lms-dropdown [options]="yardLocalSelectedList" [tabindex]='tabIndex + 25' #yardLocalSelectedDropDown (onChange)="yardLocalSelectedDropDown.resetFilter()"
                        formControlName="yardLocalSelected" [filter]="true"></lms-lms-dropdown>
                </li>
            </ul>
        </div>
    </div>
    <div class="loco-filters features-col">
        <h2>Features</h2>
        <ul>
            <li>
                <lms-lms-dropdown styleClass="feat-drpdwn" [tabindex]='tabIndex + 27' #locoFeaturesListFirstDropDown [options]="locoFeaturesListFirst"
                    formControlName="features1" (onChange)="fillFeatureListSecond($event);locoFeaturesListFirstDropDown.resetFilter()"
                    [filter]="true"></lms-lms-dropdown>
                <p-checkbox styleClass="feat-chkbx" [tabindex]='tabIndex + 29' name="features1" label="Exclude" value="Ys" formControlName="features1Exclude"
                    binary="true" [disabled]="!locoForm.controls.features1.value"></p-checkbox>
            </li>
            <li>
                <lms-lms-dropdown styleClass="feat-drpdwn" [tabindex]='tabIndex + 30' #locoFeaturesListSecondDropDown [options]="locoFeaturesListSecond"
                    formControlName="features2" (onChange)="fillFeatureListThird($event); locoFeaturesListSecondDropDown.resetFilter()"
                    [filter]="true"></lms-lms-dropdown>
                <p-checkbox styleClass="feat-chkbx" [tabindex]='tabIndex + 32' name="features2" label="Exclude" value="Y" formControlName="features2Exclude"
                    [disabled]="!locoForm.controls.features2.value"></p-checkbox>
            </li>
            <li>
                <lms-lms-dropdown styleClass="feat-drpdwn" [tabindex]='tabIndex + 33' #locoFeaturesListThirdDropDown [options]="locoFeaturesListThird"
                    formControlName="features3" [filter]="true" (onChange)=" locoFeaturesListThirdDropDown.resetFilter()"></lms-lms-dropdown>
                <p-checkbox styleClass="feat-chkbx" [tabindex]='tabIndex + 35' name="features3" label="Exclude" value="Y" formControlName="features3Exclude"
                    [disabled]="!locoForm.controls.features3.value"></p-checkbox>
            </li>
        </ul>
        <div class="offline-stored">
            <div>
                <h2> Offline</h2>
                <span class="radios">
        <p-radioButton (onClick)="toggleExcludeIncludeOnlyState('offline')" [tabindex]="locoForm.controls['stored'].value === 'only' ?tabIndex + 36 : -1" name="offline" value="exclude" [disabled]="locoForm.controls['stored'].value === 'only'"
          label="Exclude" formControlName="offline" labelStyleClass="radio-btn-lable"></p-radioButton>
</span>
                <span class="radios">
        <p-radioButton (onClick)="toggleExcludeIncludeOnlyState('offline')" [tabindex]="locoForm.controls['stored'].value !== 'only' ?tabIndex + 37 : -1" name="offline" value="include" [disabled]="locoForm.controls['stored'].value === 'only'"
          label="Include" formControlName="offline" labelStyleClass="radio-btn-lable"> </p-radioButton>
       </span>
                <span class="radios">
        <p-radioButton (onClick)="toggleExcludeIncludeOnlyState('offline')" [tabindex]="locoForm.controls['stored'].value !== 'only' ?tabIndex + 38 : -1" name="offline" value="only" [disabled]="locoForm.controls['stored'].value === 'only'"
          label="Only" formControlName="offline" labelStyleClass="radio-btn-lable"></p-radioButton>
        </span>
            </div>
            <br><br>
            <div>
                <h2> Stored</h2>
                <span class="radios"><p-radioButton (onClick)="toggleExcludeIncludeOnlyState('stored')" [tabindex]="locoForm.controls['offline'].value !== 'only' ? tabIndex + 39 : -1" [disabled]="locoForm.controls['offline'].value === 'only'"
          name="stored" value="exclude" label="Exclude" formControlName="stored" labelStyleClass="radio-btn-lable"></p-radioButton>
        </span>
                <span class="radios">
        <p-radioButton (onClick)="toggleExcludeIncludeOnlyState('stored')" [tabindex]="locoForm.controls['offline'].value !== 'only' ?tabIndex + 40 : -1" name="stored" [disabled]="locoForm.controls['offline'].value === 'only'"
          value="include" label="Include" formControlName="stored" labelStyleClass="radio-btn-lable"></p-radioButton>
</span>
                <span class="radios">
        <p-radioButton (onClick)="toggleExcludeIncludeOnlyState('stored')" [tabindex]="locoForm.controls['offline'].value !== 'only' ?tabIndex + 41 : -1" name="stored" [disabled]="locoForm.controls['offline'].value === 'only'"
          value="only" label="Only" formControlName="stored" labelStyleClass="radio-btn-lable"></p-radioButton>
</span>
            </div>
        </div>
        <div>
            <p-checkbox name="groupname" label="? Locomotives" [tabindex]='tabIndex + 42' [binary]="true" value="val1" formControlName="questionMark"></p-checkbox>
        </div>
    </div>
</div>